import { AuxCheckboxGroup } from "@blk/aladdin-react-components-es";
import { isNil } from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { useWidgetChildrenId, useWidgetCurrentDisplayOptions } from "components/widgets/hooks/use-current-widget";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setCurrentStatusDisplayOptions } from "store/current-dashboard";
import { getCurrentLocalTime } from "common/date-utils";
var TelemetryDimension;
(function (TelemetryDimension) {
    TelemetryDimension["DisplayTotals"] = "DisplayTotals";
    TelemetryDimension["Scale"] = "Scale";
    TelemetryDimension["All"] = "DisplayTotalsAndScale";
    TelemetryDimension["None"] = "None";
})(TelemetryDimension || (TelemetryDimension = {}));
export const InsSettingsDisplayOptions = (props) => {
    const { sectionId, widgetId } = props, childrenId = useWidgetChildrenId(sectionId, widgetId), dispatch = useDispatch(), displayAppearenceOptions = useWidgetCurrentDisplayOptions(sectionId, widgetId), { showTotals, showScale, showRowNumber, showTotalRows } = displayAppearenceOptions ?? {};
    const dataCheckboxAppearenceOptions = [];
    if (!isNil(showTotals)) {
        dataCheckboxAppearenceOptions.push({
            checked: showTotals,
            eventData: "showTotals",
            label: language.en.skeleton.settingsMenu.displayOptions.displayTotals
        });
    }
    if (!isNil(showScale)) {
        dataCheckboxAppearenceOptions.push({
            checked: showScale,
            eventData: "showScale",
            label: language.en.skeleton.settingsMenu.displayOptions.scale
        });
    }
    if (!isNil(showRowNumber)) {
        dataCheckboxAppearenceOptions.push({
            checked: showRowNumber,
            eventData: "showRowNumber",
            label: language.en.skeleton.settingsMenu.displayOptions.rowNumber
        });
    }
    if (!isNil(showTotalRows)) {
        dataCheckboxAppearenceOptions.push({
            checked: showTotalRows,
            eventData: "showTotalRows",
            label: language.en.skeleton.settingsMenu.displayOptions.displayRowTotal
        });
    }
    const onCheckboxChanged = (data) => {
        let displayRowNumber = showRowNumber, displayScale = showScale, displayTotal = showTotals, displayTotalRows = showTotalRows;
        data.detail.value?.forEach((checkbox) => {
            if (checkbox.eventData === "showTotals") {
                displayTotal = checkbox.checked;
            }
            if (checkbox.eventData === "showScale") {
                displayScale = checkbox.checked;
            }
            if (checkbox.eventData === "showRowNumber") {
                displayRowNumber = checkbox.checked;
            }
            if (checkbox.eventData === "showTotalRows") {
                displayTotalRows = checkbox.checked;
            }
        });
        let eventDimension = TelemetryDimension.None;
        if (displayScale && displayTotal) {
            eventDimension = TelemetryDimension.All;
        }
        else if (displayScale) {
            eventDimension = TelemetryDimension.Scale;
        }
        else if (displayTotal) {
            eventDimension = TelemetryDimension.DisplayTotals;
        }
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ChangeWidgetSettingsDisplayAs, properties: { LocalTimestamp: getCurrentLocalTime() } }, { selectedKindOfDisplay: eventDimension });
        dispatch(setCurrentStatusDisplayOptions({
            childrenId,
            sectionId,
            showRowNumber: displayRowNumber,
            showScale: displayScale,
            showTotalRows: displayTotalRows,
            showTotals: displayTotal,
            widgetId
        }));
    };
    return React.createElement(AuxCheckboxGroup, { isStacked: true, data: dataCheckboxAppearenceOptions, label: dataCheckboxAppearenceOptions.length === 1 ? "" : language.en.skeleton.settingsMenu.displayOptions.display, onCheckboxGroupChanged: onCheckboxChanged });
};
